import { Component, OnInit, inject } from '@angular/core'
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel } from '@angular/material/snack-bar'
import { MatButtonModule } from '@angular/material/button'
import { BricksIconComponent } from '@enbw_bricks/ui'

@Component({
  selector: 'app-snackbar-content',
  templateUrl: './snackbar.content.component.html',
  styleUrl: './snackbar.content.component.scss',
  imports: [MatButtonModule, MatSnackBarLabel, BricksIconComponent],
})
export class SnackbarContentComponent implements OnInit {
  data = inject<{
    message: string
    actionLabel?: string
    icon?: string
  }>(MAT_SNACK_BAR_DATA)

  message = ''
  actionLabel: string | undefined
  icon: string | undefined

  ngOnInit() {
    this.message = this.data.message || ''
    this.actionLabel = this.data.actionLabel || 'Close'
    this.icon = this.data.icon || 'bricks-info'
  }
}
